module.exports = __webpack_public_path__ + "img/form_1@2x.7f86a014.png";